// @flow
import { Fragment, useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { stylesheet } from 'typestyle';

import LumeraPersistGate from '@components/LumeraPersistGate';

import DesignYourOwnRing from '@components/dyor/Container';
import DyorDataWrapper from '@components/DyorDataWrapper';

import Filters from '@components/diamondSearch/Filters';
import Results from '@components/diamondSearch/Results';
import MarketingContent from '@components/diamondSearch/MarketingContent';
import SettingCompatibility from '../../diamondSearch/SettingCompatibility';

import PageSeoContentProvider from '../../PageSeoContentApplier';
import { CanonicalUrlProvider } from '../../../contexts/canonicalUrl';
import { SeoContentProvider } from '../../../contexts/seoContent';

import type { RailsContextType } from '@types/misc';

type TProps = {
  dyor: boolean,
  railsContext: RailsContextType
};

const css = stylesheet({
  container: {
    width: '100%',
    overflow: 'hidden'
  }
});

function Catalog({ dyor, railsContext }: TProps) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: 'SYNC_DIAMOND_FILTERS_FROM_URI',
      url: railsContext.location,
      callback: () => {
        dispatch({
          type: 'FETCH_INITIAL_DIAMONDS',
          looseDiamonds: !dyor
        });
      }
    });
  }, [dispatch, railsContext.location, dyor]);

  return (
    <Fragment>
      {dyor && (
        <DyorDataWrapper>
          <DesignYourOwnRing />
          <SettingCompatibility />
        </DyorDataWrapper>
      )}
      <div className={css.container}>
        <MarketingContent />
        <Filters dyor={dyor} />
        <Results dyor={dyor} />
      </div>
    </Fragment>
  );
}

export default (props: TProps, railsContext: RailsContextType) =>
  () => {
    const store = ReactOnRails.getStore('SharedReduxStore');

    return (
      <Provider store={store}>
        <CanonicalUrlProvider debounceRate={50}>
          <SeoContentProvider>
            <PageSeoContentProvider>
              <LumeraPersistGate>
                <Catalog {...{ ...props, railsContext }} />
              </LumeraPersistGate>
            </PageSeoContentProvider>
          </SeoContentProvider>
        </CanonicalUrlProvider>
      </Provider>
    );
  };
